module.exports = __webpack_public_path__ + "img/exit.42b8ebca.svg";